import styled, { css } from 'styled-components'
import colors from 'utils/styling/colors'

export const ChipsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

// The product list flows with the modal body — the modal's single outer
// scroll (maxHeight + overflow on the panel) handles long lists, avoiding
// nested scrollbars.
export const ProductList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: ${colors('gray5')};
`

export const ChipRemoveButton = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
`

export const ProductRow = styled.label<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  border-radius: 4px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};

  ${({ disabled }) =>
    !disabled &&
    css`
      &:hover {
        background-color: ${colors('palePrimary')};
      }
    `}
`

export const ProductCheckbox = styled.input`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  accent-color: ${colors('brand')};

  &:disabled {
    cursor: not-allowed;
  }
`

export const StatusBadge = styled.span`
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  background-color: ${colors('gray5')};
  color: ${colors('gray2')};
`
